import { useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment'
import 'moment/locale/th'

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions(props) {
    // const { surveyBuildings,
    //     surveyBuildingLoading,
    //     surveyImagesLoading,
    //     landImagesUrl,
    //     buildingImagesURL,
    //     allBuildingInfo,
    //     ltaxBuildingLoading,
    //     ltaxOnlineData,
    //     ltaxOnlineBuildingLoading
    // } = props
    const {
        surveyBuildings,
        surveyBuildingLoading,
        surveyImagesLoading,
        landImagesUrl,
        buildingImagesURL,
        allBuildingInfo,
        ltaxBuildingLoading,
        ltaxOnlineBuildings = [], // 🟢 รับค่าพร้อมกำหนด Default value เป็น Array ว่าง
        ltaxOnlineLands = [],     // 🟢 รับค่าที่ดินเพิ่ม
        ltaxOnlineBuildingLoading
    } = props;
    const [expanded, setExpanded] = useState({
        panel1: false,
        panel2: false,
        panel3: false,
        panel4: false,
        panel5: false,
    })

    const handleChange = (key) => {
        switch (key) {
            case 'panel1':
                setExpanded({ ...expanded, panel1: !expanded.panel1 })
                break;
            case 'panel2':
                setExpanded({ ...expanded, panel2: !expanded.panel2 })
                break;
            case 'panel3':
                setExpanded({ ...expanded, panel3: !expanded.panel3 })
                break;
            case 'panel4':
                setExpanded({ ...expanded, panel4: !expanded.panel4 })
                break;
            case 'panel5':
                setExpanded({ ...expanded, panel5: !expanded.panel5 })
                break;

            default:
                break;
        }
    };

    return (
        <Box>
            <Accordion expanded={expanded.panel1} onChange={() => handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>ข้อมูลสิ่งปลูกสร้าง ระบบสำรวจภาคสนาม</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflow: 'scroll', maxHeight: '15ch' }}>
                    {surveyBuildingLoading ?
                        <Box sx={{ display: 'flex' }}>
                            <CircularProgress />
                        </Box>
                        : surveyBuildings?.length > 0
                            ? <Box>{surveyBuildings.map((building, index) => (
                                <Typography key={index}>{`บ้านเลขที่ : ${building.address} หมู่ : ${building.moo || '-'} ถนน : ${building.road || '-'} เจ้าของ : ${building.first_name || ''} ${building.last_name || ''} โทร : ${building.telephone_no || '-'} `}</Typography>
                            ))}</Box>
                            : 'ไม่มีข้อมูล'}
                </AccordionDetails>
            </Accordion>
            {/* <Accordion expanded={expanded.panel2} onChange={() => handleChange('panel2')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>ภาพแปลงที่ดิน ระบบสำรวจภาคสนาม</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflow: 'scroll', maxHeight: '20ch' }}>
                    <ImageList cols={1}>
                        {surveyImagesLoading ?
                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress />
                            </Box>
                            : landImagesUrl?.length > 0 ?
                                landImagesUrl?.map((item, index) => (
                                    <ImageListItem key={index}>
                                        <img
                                            src={item.url}
                                            srcSet={item.url}
                                            alt={item.parcelCode}
                                            loading="lazy"
                                        />
                                        <ImageListItemBar
                                            title={`เลขที่โฉนด:${item.dn}`}
                                            // subtitle={`ภาพสำรวจเมื่อ ${moment(item.uploadDate).add(543, 'year').format('วันที่ DD MMMM YYYY เวลา HH:mm:ss')}`}
                                            actionIcon={
                                                <IconButton
                                                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                                    aria-label={`info about title`}
                                                >
                                                    <InfoIcon />
                                                </IconButton>
                                            }
                                        />
                                    </ImageListItem>
                                )) : 'ไม่มีข้อมูล'}
                    </ImageList>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded.panel3} onChange={() => handleChange('panel3')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>ภาพสิ่งปลูกสร้าง ระบบสำรวจภาคสนาม</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflow: 'scroll', maxHeight: '20ch' }}>
                    <ImageList cols={1}>
                        {surveyImagesLoading ?
                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress />
                            </Box>
                            : buildingImagesURL?.length > 0 ?
                                buildingImagesURL?.map((item, index) => (
                                    <ImageListItem key={index}>
                                        <img
                                            src={item.url}
                                            srcSet={item.url}
                                            alt={item.parcelCode}
                                            loading="lazy"
                                        />
                                        <ImageListItemBar
                                            title={`บ้านเลขที่:${item.address}`}
                                            subtitle={`ภาพสำรวจเมื่อ ${moment(item.uploadDate).add(543, 'year').format('วันที่ DD MMMM YYYY เวลา HH:mm:ss')}`}
                                            actionIcon={
                                                <IconButton
                                                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                                    aria-label={`info about title`}
                                                >
                                                    <InfoIcon />
                                                </IconButton>
                                            }
                                        />
                                    </ImageListItem>
                                )) : 'ไม่มีข้อมูล'}
                    </ImageList>
                </AccordionDetails>
            </Accordion> */}
            {/* <Accordion expanded={expanded.panel5} onChange={() => handleChange('panel5')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>ข้อมูลสิ่งปลูกสร้าง LTAX Online</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflow: 'scroll', maxHeight: '15ch' }}>
                    {ltaxOnlineBuildingLoading ?
                        <Box sx={{ display: 'flex' }}>
                            <CircularProgress />
                        </Box>
                        : ltaxOnlineData?.length > 0
                            ? <Box>{ltaxOnlineData.map((building, index) => (
                                <Typography key={index}>{`บ้านเลขที่ : ${building.address} หมู่ : ${building.moo || '-'} ถนน : ${building.road || '-'} ตำบล : ${building.tumbol || '-'} ประเภท : ${building.building_type || '-'} เนื้อที่รวม : ${building.area || '-'} ตรม. อายุ : ${building.b_age || '-'} เจ้าของสิ่งปลูกสร้าง : ${building.owner || '-'}`}</Typography>
                            ))}</Box>
                            : 'ไม่มีข้อมูล'}
                </AccordionDetails>
            </Accordion> */}
            {/* 🏢 Panel 5: ข้อมูลสิ่งปลูกสร้าง LTAX Online */}
            <Accordion expanded={expanded.panel5} onChange={() => handleChange('panel5')}>
                <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
                    <Typography>ข้อมูลสิ่งปลูกสร้าง LTAX Online</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflowY: 'auto', maxHeight: '20ch' }}>
                    {ltaxOnlineBuildingLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : ltaxOnlineBuildings?.length > 0 ? (
                        <Box>
                            {ltaxOnlineBuildings.map((building, index) => (
                                <Typography key={index} variant="body2" sx={{ mb: 1, borderBottom: '1px dashed #ccc', pb: 0.5 }}>
                                    {`บ้านเลขที่ : ${building.address || '-'} หมู่ : ${building.moo || '-'} ถนน : ${building.road || '-'} ตำบล : ${building.tumbol || '-'} ประเภท : ${building.building_type || '-'} เนื้อที่รวม : ${building.area || '-'} ตรม. อายุ : ${building.b_age || '-'} เจ้าของสิ่งปลูกสร้าง : ${building.owner || '-'}`}
                                </Typography>
                            ))}
                        </Box>
                    ) : (
                        <Typography color="text.secondary">ไม่มีข้อมูลสิ่งปลูกสร้าง</Typography>
                    )}
                </AccordionDetails>
            </Accordion>

            {/* 🌾 Panel ข้อมูลที่ดิน LTAX Online */}
            <Accordion expanded={expanded.panel6} onChange={() => handleChange('panel6')}>
                <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
                    <Typography>ข้อมูลที่ดิน LTAX Online</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflowY: 'auto', maxHeight: '20ch' }}>
                    {ltaxOnlineBuildingLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : ltaxOnlineLands?.length > 0 ? (
                        <Box>
                            {ltaxOnlineLands.map((land, index) => (
                                <Typography
                                    key={index}
                                    variant="body2"
                                    sx={{ mb: 1, borderBottom: '1px dashed #ccc', pb: 0.5 }}
                                >
                                    {`รหัสแปลง : ${land.parcel_code || '-'} `}
                                    {`ประเภท : ${land.parcel_type || '-'} `}
                                    {`เลขที่โฉนด/เอกสารสิทธิ์ : ${land.dn || '-'} `}
                                    {`ระวาง : ${land.rawang || '-'} `}
                                    {`เลขที่ดิน : ${land.land_no || '-'} `}
                                    {`หน้าสำรวจ : ${land.survey_no || '-'} `}
                                    {`เนื้อที่ : ${land.area || '-'} ไร่ `}
                                    {`เจ้าของที่ดิน : ${land.owner || '-'}`}
                                </Typography>
                            ))}
                        </Box>
                    ) : (
                        <Typography color="text.secondary">ไม่มีข้อมูลที่ดิน</Typography>
                    )}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
